import React from "react";
import { Flex, Link } from "../components";
import { serialize } from "../utils";

const tests = [4365,4366,4367,4368,1423,1424,1425,1426,1427,1428,1429];

const practiceTest = {
  subject_id: 55,
  unit_id: 223,
  university_degree_department_id: 61,
  s1_topic_id: 2
};

const Home = () => (
  <Flex column>
    <h1>Home</h1>
    <h3>Development test lists:</h3>
    <ul>
      {tests &&
        tests.map(item => (
          <li key={item}>
            <Link to={`/test/${item}`}>{item}</Link>
          </li>
        ))}
    </ul>
    <ul>
      <li>
        <Link to={`/practiceTest?${serialize(practiceTest)}`}>Practice Test</Link>
      </li>
    </ul>
  </Flex>
);

export default Home;
